import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>Introduction</Summary>
        <Details>
          <Text></Text>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
